var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.592773 29.3732C0.592773 19.2847 0.592773 14.2404 2.55614 10.3871C4.28317 6.99765 7.03891 4.24191 10.4284 2.51488C14.2817 0.551514 19.326 0.551514 29.4145 0.551514H51.4103C61.4989 0.551514 66.5432 0.551514 70.3963 2.51488C73.7858 4.24191 76.5416 6.99765 78.2686 10.3871C80.232 14.2404 80.232 19.2847 80.232 29.3732V51.369C80.232 61.4576 80.232 66.5019 78.2686 70.355C76.5416 73.7445 73.7858 76.5003 70.3963 78.2273C66.5432 80.1907 61.4989 80.1907 51.4103 80.1907H29.4145C19.326 80.1907 14.2817 80.1907 10.4284 78.2273C7.03891 76.5003 4.28317 73.7445 2.55614 70.355C0.592773 66.5019 0.592773 61.4576 0.592773 51.369V29.3732Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6478 64.413C36.0715 64.413 39.6618 60.8228 39.6618 56.399V48.385H31.6478C27.2241 48.385 23.6338 51.9753 23.6338 56.399C23.6338 60.8228 27.2241 64.413 31.6478 64.413Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6338 40.3709C23.6338 35.9472 27.2241 32.3569 31.6478 32.3569H39.6618V48.385H31.6478C27.2241 48.385 23.6338 44.7947 23.6338 40.3709Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6338 24.3431C23.6338 19.9194 27.2241 16.3291 31.6478 16.3291H39.6618V32.3571H31.6478C27.2241 32.3571 23.6338 28.7668 23.6338 24.3431Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6621 16.3291H47.6761C52.0999 16.3291 55.6901 19.9194 55.6901 24.3431C55.6901 28.7668 52.0999 32.3571 47.6761 32.3571H39.6621V16.3291Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6901 40.3714C55.6901 44.7952 52.0999 48.3854 47.6761 48.3854C43.2524 48.3854 39.6621 44.7952 39.6621 40.3714C39.6621 35.9477 43.2524 32.3574 47.6761 32.3574C52.0999 32.3574 55.6901 35.9477 55.6901 40.3714Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0841,
    height: 48.0841,
    fill: "white",
    transform: "translate(15.6191 16.3291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.38be4a2082aece6bbc6ecd1a3fa24cdf.svg";
export { ForwardRef as ReactComponent };